<script lang="ts">
	import { maxCharactersForInscription } from "../../../../core/schema/productOptionsConstants.js";
	import LabelledInput from "../Form/LabelledInput.svelte";
	import { inflectCharacter } from "../../../../core/schema/utils/inflectCharacter.js";
	import napisdort from "../../../../core/assets/icons/napisdort.svg";
	import Button from "../Button.svelte";
	import plus from "../../../../core/assets/icons/btn-plus.svg?raw";
	import ProductOptionHeader from "./ProductOptionHeader.svelte";
	import { calculatePriceForProductOption } from "../../../../core/schema/utils/calculatePriceForProductOption.js";
	import { ProductOption } from "../../../../core/schema/ProductOption.js";
	import type { ProductInscription } from "../../../../core/schema/ProductInscription.js";
	import { ProductInscriptionStatus } from "../../../../core/schema/ProductInscriptionStatus.js";

	export let inscription: ProductInscription | undefined;
	export let updateInscription: (inscription: ProductInscription) => void;
	export let basePrice: number;
	export let minimalPricesForOptions: Record<ProductOption, number>;
	export let changed: boolean | undefined;

	const newInscription = structuredClone(inscription) ?? {
		status: ProductInscriptionStatus.ToDo,
		text: "",
	};

	function onChange(_inscription: typeof inscription): void {
		if (changed === undefined) {
			changed = false;
			return;
		}
		changed = true;
	}
	$: onChange(newInscription);

	function validateInput(target: EventTarget | null): void {
		const input = target as HTMLInputElement;
		const value = input.value.trim();

		const usedCharacters = value.length;
		if (usedCharacters === 0) {
			input.setCustomValidity("Nápis je povinný.");
		} else if (usedCharacters > maxCharactersForInscription) {
			input.setCustomValidity(
				`Nápis může mít maximálně ${maxCharactersForInscription} ${inflectCharacter(maxCharactersForInscription)}. Aktuálně využíváte ${usedCharacters} ${inflectCharacter(usedCharacters)}.`,
			);
		} else {
			input.setCustomValidity("");
		}
		input.reportValidity();
	}

	$: minimalPrice = minimalPricesForOptions[ProductOption.Inscription];
	$: currentPrice = calculatePriceForProductOption(basePrice, ProductOption.Inscription, newInscription);
</script>

<ProductOptionHeader name="Přidat nápis" image={napisdort} price={currentPrice} {minimalPrice}>
	Ručně psané jméno nebo krátký vzkaz udělá z dortu osobní záležitost.
</ProductOptionHeader>

<div class="flex w-full gap-2">
	<LabelledInput
		id="inscription"
		placeholder="Vložte nápis"
		class="flex-1"
		required
		fullWidth
		clearable
		showValid
		alwaysEnableClear
		bind:value={newInscription.text}
		on:input={(event) => {
			validateInput(event.target);
		}}
		withoutLabel
	/>
</div>

<Button
	icon={plus}
	iconClass="w-5 h-5"
	class="mt-4 self-end"
	on:click={() => {
		updateInscription({
			...newInscription,
			text: newInscription.text.trim(),
		});
	}}
>
	Uložit úpravu
</Button>
